// @flow

import React, { type Node, Suspense } from 'react';
import { safeLazy } from '@tectonics/utils/modules';

const UberLookAndFeel = safeLazy(() => import('./uber'));

export function LookAndFeelRouter(props: Props): Node {
  return (
    <Suspense fallback={<div>Carregando...</div>}>
      <LookAndFeelImpl {...props} />
    </Suspense>
  );
}

function LookAndFeelImpl(props: Props): Node {
  const { lookAndFeelCode } = props;

  switch (lookAndFeelCode) {
    case 'uber':
      return <UberLookAndFeel />;
    default:
      throw new Error(`Look and feel "${lookAndFeelCode}" not recognized`);
  }
}

type Props = {
  lookAndFeelCode: string,
};
